import "./App.css";
import { lazy, Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import "./web.config";
// import Login from './components/User/Login';
import Login from "./components/User/Log";
import AccountDashboard from "./components/Account/AccountDashboard";
// import Distributor from './components/Distributor/Distributor';
import DistributorDashboard from "./components/Distributor/DistributorDashboard";
import ManufacturerDashboard from "./components/Manufacturer/ManufacturerDashboard";
import DirectOrder from "./components/DirectOrder/DirectOrder";
import ConsignmentOrder from "./components/ConsignmentOrder/ConsignmentOrder";
import Orders from "./components/Orders/Orders";
// import InvoiceDashboard from './components/Invoices/InvoiceDashboard';
import InvoiceDashboard from "./components/Invoices/DashNew";
import InvoiceHome from "./components/Invoices/InvoiceHome";
import IVRFormAdd from "./components/IVR/IVRFormAdd";
import IVRSubmissions from "./components/IVR/IVRSubmissions";
import ProductLog from "./components/ProductLog/ProductLog";
import IVRManufacturers from "./components/IVR/IVRManufacturers";
import AddIVRManufacturer from "./components/IVR/AddIVRManufacturer";
import ViewIVRManufacturer from "./components/IVR/ViewIVRManufacturer";
import ProductUsage from "./components/ProductUsage/ProductUsage";
import AccountConsignmentDashboard from "./components/Account/AccountConsignmentDashboard";
import Layout from "./components/Layout/Layout";
import AuthProvider, { useAuth } from "./components/AuthProvider";
import Home from "./components/Home/Home";
import AccountDetails from "./components/Account/AccountDetails";
import ApprovalsDashboard from "./components/Approvals/ApprovalsDashboard";
import AccountEnrollmentWizard from "./components/AccountEnrollment/AccountEnrollmentWizard";
import PrivateRoute from "./components/PrivateRoute";
import ASUsers from "./components/ASUsers/ASUsers";
import ASUserDetails from "./components/ASUsers/ASUserDetails";
// import ManufacturerDetailsTab from './components/Manufacturer/ManufacturerDetailsTab';
import ManufacturerDetails from "./components/Manufacturer/ManufacturerDetails";
import ProductGroupDetails from "./components/Manufacturer/ProductGroupDetails";
import DistributorDetails from "./components/Distributor/DistributorDetails";
import ForgotPassword from "./components/User/ForgotPassword";
import Reset from "./components/User/Reset";
import SetPassword from "./components/User/SetPassword";
import UserDashboard from "./components/UserTable/UserDashboard";
import UserDetailsPage from "./components/UserTable/UserDetailsPage";
import PaymentsDashboard from "./components/PaymentsDashboard/PaymentsDashboard";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import NewCommissionContracts from "./components/Commissions/NewCommissionContract";
import { BreadcrumbProvider } from "./common/breadcrumbs/breadcrumb-context";
import DistributorCommissionStatements from "./components/Distributor/DistributorCommissionStatements";
import ManufacturerContractsDashboard from "./components/ManufacturerCommissionContract/ManufacturerContractsDashboard";
import NewManufacturerContract from "./components/ManufacturerCommissionContract/NewManufacturerContract";
import NewDistributorReferralContract from "./components/DistributorReferralContract/NewDistributorReferralContract";
import CommissionStatements from "./components/CommissionStatements/CommissionStatements";
import CommissionStatementsDetails from "./components/CommissionStatements/CommissionStatementsDetails";
import CommissionStatementsDistributor from "./components/CommissionStatements/CommissionStatementsDistributor";
import CommissionStatementsProducts from "./components/CommissionStatements/CommissionStatementsProducts";
import NewCommissionContractTemp from "./components/Commissions/NewCommissionContractTemp";
import ReportsHome from "./components/Reports/ReportHome";
import ReportsDashboard from "./components/Reports/ReportsDashboard";
import QuickUpdateCcp from "./components/Commissions/QuickUpdateCcp";
import NewForm from "./components/NewIVR/NewForm";
import IVRDashboard from "./components/IVR/IVRDashboard";
import AdminTools from "./components/AdminTools/AdminTools";
import BannerAlerts from "./components/AdminTools/BannerAlerts";
import HubspotToTissueVaultSync from "./components/AdminTools/HubspotToTissueVaultSync";
import TissueVaultToHubspotSync from "./components/AdminTools/TissueVaultToHubspotSync";
import ShippingSetup from "./components/AdminTools/ShippingSetup";
import ContractRightsSettings from "./components/AdminTools/ContractRightsSettings";
import ProductCategories from "./components/AdminTools/ProductCategories";
import UserPermissions from "./components/UserPermissions/UserPermissions";
import IVRDetails from "./components/IVR/IVRDetails";
import IVRProduct from "./components/IVR/IVRProduct";
import ViewNewDirectOrder from "./components/DirectOrder/ViewNewDirectOrder";
import NewDirectOrderRoute from "./components/DirectOrder/NewDirectOrderRoute";
import OpenOrderForm from "./components/OpenOrder/OpenOrderForm";
import OpenOrderStatus from "./components/OpenOrder/OpenOrderStatus";

ModuleRegistry.registerModules([AllCommunityModule]);

// Hidden routes (Phase 2 E18): code-split so the old Home bundle is unaffected.
const ExecutiveDashboard = lazy(() =>
  import("./components/AABI/executive/ExecutiveDashboard"),
);
const RecentActivityPage = lazy(() =>
  import("./components/AABI/executive/RecentActivityPage"),
);


// Admin users see the Executive Dashboard at "/"; everyone else keeps Home.
// (The dashboard redirects non-admins to "/", so it must never render for them here.)
const HomeRoute = () => {
  const { user } = useAuth();
  if (user?.Type === "Admin") {
    return (
      <Suspense fallback={null}>
        <ExecutiveDashboard />
      </Suspense>
    );
  }
  return <Home />;
};

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/Login" element={<Login />} />
            <Route path="/Forgot" element={<ForgotPassword />} />
            <Route path="/Reset" element={<Reset />} />
            <Route path="/SetPassword" element={<SetPassword />} />
            <Route path="/OpenOrder" element={<OpenOrderForm />} />
            <Route path="/OpenOrder/Status" element={<OpenOrderStatus />} />
            <Route path="/OpenOrder/ViewOrder" element={<ViewNewDirectOrder publicMode />} />
            {/* <Route path="/Register" element={<Register />} /> */}
            <Route element={<PrivateRoute />}>
              <Route
                path="/*"
                element={
                  <BreadcrumbProvider>
                    <Layout>
                      <Routes>
                        {/* <Route
                          path="/"
                          element={<Home />}
                          onEnter={requireAuth}
                        /> */}
                        <Route path="/" element={<HomeRoute />} />
                        <Route
                          path="/ExecutiveDashboard"
                          element={
                            <Suspense fallback={null}>
                              <ExecutiveDashboard />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/RecentActivity"
                          element={
                            <Suspense fallback={null}>
                              <RecentActivityPage />
                            </Suspense>
                          }
                        />

                        <Route path="/Account" element={<AccountDetails />} />
                        <Route
                          path="/Account/:id"
                          element={<AccountDetails />}
                        />
                        <Route
                          path="/AccountDashboard"
                          element={<AccountDashboard />}
                        />
                        <Route
                          path="/AccountEnrollment"
                          element={<AccountEnrollmentWizard />}
                        />
                        <Route
                          path="/Distributor"
                          element={<DistributorDetails />}
                        />
                        <Route
                          path="/Distributor/:id"
                          element={<DistributorDetails />}
                        />
                        <Route
                          path="/DistributorDashboard"
                          element={<DistributorDashboard />}
                        />
                        <Route
                          path="/Manufacturer"
                          element={<ManufacturerDetails />}
                        />
                        <Route
                          path="/Manufacturer/:id"
                          element={<ManufacturerDetails />}
                        />
                        <Route
                          path="/Manufacturer/:manufacturerId/ProductGroup/:productGroupId"
                          element={<ProductGroupDetails />}
                        />
                        <Route
                          path="/ManufacturerDashboard"
                          element={<ManufacturerDashboard />}
                        />
                        <Route path="/DirectOrder" element={<DirectOrder />} />
                        <Route
                          path="/DirectOrder/:id"
                          element={<ViewNewDirectOrder />}
                        />
                        <Route
                          path="/DirectOrderLegacy/:id"
                          element={<DirectOrder />}
                        />
                        <Route
                          path="/ViewNewDirectOrder/:id"
                          element={<ViewNewDirectOrder />}
                        />
                        <Route
                          path="/NewDirectOrder"
                          element={<NewDirectOrderRoute />}
                        />
                        <Route
                          path="/NewDirectOrder/:id"
                          element={<NewDirectOrderRoute />}
                        />
                        <Route
                          path="/ConsignmentOrder"
                          element={<ConsignmentOrder />}
                        />
                        <Route
                          path="/ConsignmentOrder/:id"
                          element={<ConsignmentOrder />}
                        />
                        <Route
                          path="/ProductUsage"
                          element={<ProductUsage />}
                        />
                        <Route
                          path="/ProductUsage/:id"
                          element={<ProductUsage />}
                        />
                        <Route
                          path="/ApprovalsDashboard"
                          element={<ApprovalsDashboard />}
                        />
                        <Route path="/Orders" element={<Orders />} />
                        <Route
                          path="/InvoiceDashboard"
                          element={<InvoiceDashboard />}
                        />
                        <Route
                          path="/InvoiceHome/:id"
                          element={<InvoiceHome />}
                        />
                        <Route
                          path="/IVRDashboard"
                          element={<IVRDashboard />}
                        />
                        <Route
                          path="/IVRDetails/:id"
                          element={<IVRDetails />}
                        />
                        <Route path="/IVRProduct/:id" element={<IVRProduct />} />
                        <Route path="/NewForm" element={<NewForm />} />

                        <Route path="/IVR" element={<IVRFormAdd />} />
                        <Route path="/IVR/:id" element={<IVRFormAdd />} />
                        <Route
                          path="/IVRSubmissions-legacy"
                          element={<IVRSubmissions />}
                        />
                        <Route
                          path="/IVRManufacturers/:id"
                          element={<IVRManufacturers />}
                        />
                        <Route
                          path="/AddIVRManufacturer/:id"
                          element={<AddIVRManufacturer />}
                        />
                        <Route
                          path="/ViewIVRManufacturer/:id"
                          element={<ViewIVRManufacturer />}
                        />
                        <Route path="/ProductLog" element={<ProductLog />} />
                        <Route
                          path="/AccountConsignment/:id"
                          element={<AccountConsignmentDashboard />}
                        />
                        <Route path="/ASUsers" element={<ASUsers />} />
                        <Route path="/Users" element={<UserDashboard />} />
                        <Route path="/User/:id" element={<UserDetailsPage />} />
                        <Route
                          path="/ASUserDetails/:id"
                          element={<ASUserDetails />}
                        />
                        <Route
                          path="/PaymentsDashboard"
                          element={<PaymentsDashboard />}
                        />
                        {/* <Route
                          path="/Commissions"
                          element={<CommissionContracts />}
                        /> */}
                        <Route
                          path="/CommissionContract"
                          element={<NewCommissionContracts />}
                        />
                        <Route
                          path="/CommissionContractAllProducts"
                          element={<NewCommissionContractTemp />}
                        />
                        <Route
                          path="/CommissionContract/:id"
                          element={<NewCommissionContracts />}
                        />
                        <Route
                          path="/CommissionStatements"
                          element={<CommissionStatements />}
                        />
                        <Route
                          path="/CommissionStatementsDetails/:id"
                          element={<CommissionStatementsDetails />}
                        />
                        <Route
                          path="/CommissionStatementsDistributor/:id"
                          element={<CommissionStatementsDistributor />}
                        />
                        <Route
                          path="/DistributorCommissionStatements/:id"
                          element={<DistributorCommissionStatements />}
                        />
                        <Route
                          path="/ManufacturerCommissionContract"
                          element={<NewManufacturerContract />}
                        />
                        <Route
                          path="/ManufacturerCommissionContract/:id"
                          element={<NewManufacturerContract />}
                        />
                        <Route
                          path="/ManufacturerContractDashboard/:id"
                          element={<ManufacturerContractsDashboard />}
                        />
                        <Route
                          path="/DistributorReferralContract"
                          element={<NewDistributorReferralContract />}
                        />
                        <Route
                          path="/DistributorReferralContract/:id"
                          element={<NewDistributorReferralContract />}
                        />
                        <Route
                          path="/CommissionStatements"
                          element={<CommissionStatements />}
                        />
                        <Route
                          path="/CommissionStatementsProducts/:id"
                          element={<CommissionStatementsProducts />}
                        />
                        <Route
                          path="/ReportsDashboard"
                          element={<ReportsDashboard />}
                        />
                        <Route path="/Reports/:id" element={<ReportsHome />} />
                        <Route
                          path="/quickupdateccp"
                          element={<QuickUpdateCcp />}
                        />
                        <Route path="/AdminTools" element={<AdminTools />} />
                        <Route path="/BannerAlerts" element={<BannerAlerts />} />
                        <Route
                          path="/HubspotToTissueVaultSync"
                          element={<HubspotToTissueVaultSync />}
                        />
                        <Route
                          path="/TissueVaultToHubspotSync"
                          element={<TissueVaultToHubspotSync />}
                        />
                        <Route
                          path="/ShippingSetup"
                          element={<ShippingSetup />}
                        />
                        <Route
                          path="/ContractRightsSettings"
                          element={<ContractRightsSettings />}
                        />
                        <Route
                          path="/ProductCategories"
                          element={<ProductCategories />}
                        />
                        <Route
                          path="/UserPermissions"
                          element={<UserPermissions />}
                        />
                        {/* <Route
                          path="/DistributorCommissionStatements/:id"
                          element={<DistributorCommissionStatements />}
                        /> */}
                      </Routes>
                    </Layout>
                  </BreadcrumbProvider>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
